import * as yup from "yup";
import { InferType } from "yup";
import i18n from "@/i18n";

const iban = /^[A-Z]{2}[0-9A-Z]{3,30}$/;

export const SepaAccountSchema = yup.object({
  bankAccountNumber: yup
    .string()
    .matches(iban, {
      message: i18n.t("Account number / IBAN must contain up to 34 digits", {
        ns: "paymentMethods",
      }),
    })
    .required(),
  bankAccountName: yup
    .string()
    .min(
      1,
      i18n.t("Account Holder Name is required", {
        ns: "paymentMethods",
      })
    )
    .max(
      30,
      i18n.t("Account Holder Name must be less than 30 characters", {
        ns: "paymentMethods",
      })
    )
    .default(""),
  field_streetNumber: yup
    .string()
    .min(
      1,
      i18n.t("Street Number be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_streetName: yup
    .string()
    .min(
      1,
      i18n.t("Street Name must be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_email: yup
    .string()
    .email(
      i18n.t("Must be a valid email address", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_postalCode: yup
    .string()
    .min(
      1,
      i18n.t("Postal code must be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_state: yup.string().default(""),
  field_city: yup
    .string()
    .min(
      1,
      i18n.t("City must be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_country: yup
    .string()
    .min(
      1,
      i18n.t("Country must be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_passthrough4: yup.string().default(""),
  field_passthrough5: yup.string().default(""),
  field_passthrough6: yup.string().default(""),
});

export type SepaAccountSchemaType = InferType<typeof SepaAccountSchema>;

export const EditSepaAccountSchema = yup.object({
  accountHolderInfo: yup
    .object({
      addressLine1: yup.string().default(""),
      addressLine2: yup.string().default(""),
      email: yup
        .string()
        .email(
          i18n.t("Must be a valid email address", {
            ns: "paymentMethods",
          })
        )
        .required(),
      zipCode: yup
        .string()
        .min(
          1,
          i18n.t("Postal code must be a valid UK postal code", {
            ns: "paymentMethods",
          })
        )
        .required(),
      state: yup.string().default(""),
      city: yup
        .string()
        .min(
          1,
          i18n.t("City must be provided", {
            ns: "paymentMethods",
          })
        )
        .required(),
      country: yup
        .string()
        .min(
          1,
          i18n.t("Country must be provided", {
            ns: "paymentMethods",
          })
        )
        .required(),
      phone: yup.string().default(""),
    })
    .required(),
  defaultPayment: yup.boolean().default(false),
  nickname: yup.string().default(""),
});

export type EditSepaAccountSchemaType = InferType<typeof EditSepaAccountSchema>;
